import SpecialistDashboard from "./patient/components/patient-overview/specialist-dashboard";
import PatientRecordsPage from "./patient-records/patient-records-page";
import PatientDetailsView from "./patient/components/patient-drilldown/patient-details/patient-details-view";
import IOCEstimateDetailsV3 from "./estimates/components/estimate/estimate-viewV3";
import Launch from "./admissions-advisor/components/inbound/Launch";
import MasterPatientView from "./patient/components/master-ledger/master-ledger-view"
import EstimatesView from "./estimates/components/estimates-view";

import AdminLogsView from "./admin/components/admin-logs-view";
import HomeView from "./security/components/home-view";
import AccessDeniedView from "./security/components/access-denied";
import PrivacyPolicyView from "./admin/components/privacy-policy/privacy-policy-view";
import AdminReportsView from "./admin/components/admin-reports-parent";
import { ForwardDocumentsView } from "./patient/components/patient-drilldown/documents/forward-documents-view";
import ClientDocumentSign from "./patient/components/patient-drilldown/documents/client-document-sign";
import DisputeResponse from "./patient/components/patient-drilldown/transactions/dispute-response";
import CrmIntegration from "./crm/components/CrmIntegration";
import {IOCEstimateDetailsV4}
  from './estimates/components/estimate/estimate-view-v4/estimate-view-v4';
import {EstimatePreviewSummary}
  from './estimates/components/estimate/estimate-preview-summary/estimate-preview-summary';
import PaymentHubView from '@finpay-development/shared-platform/lib/esm/payment-hub/components/payment-hub-view';
import PaymentProgramView from '@finpay-development/shared-platform/lib/esm/payment-hub/components/payment-program-view';
import NewPatientView from '@finpay-development/shared-platform/lib/esm/payment-hub/components/new-patient/new-patient-view';
import MobilePaymentProgramView from '@finpay-development/shared-platform/lib/esm/payment-hub/components/mobile-payment-program-view';
import MobileNoPaymentProgramsView from '@finpay-development/shared-platform/lib/esm/payment-hub/components/mobile-no-payment-programs-view';
import HubView from '@finpay-development/shared-platform/lib/esm/payment-hub/components/hub-view';
import RecurringPaymentMethodView from '@finpay-development/shared-platform/lib/esm/payment-hub/components/recurring-payment-method-view';
import {RefinanceView} from '@finpay-development/shared-platform/lib/esm/payment-hub/components/refinance-view';

export interface RouteConfigProps {
  path: string;
  protectedPageName?: string;
  component: any;
}

const RouteConfiguration: Array<RouteConfigProps> = [
  { path: "/", component: HomeView },

  // Admin
  { path: "/admin/logs", protectedPageName: "Logs", component: AdminLogsView },
  {
    path: "/operations/reports",
    protectedPageName: "Reports",
    component: AdminReportsView,
  },
  {
    path: "/admissions-advisor/inbound",
    component: Launch,
  },
  // Patient
  {
    path: "/patient-records",
    protectedPageName: "Patient Records",
    component: PatientRecordsPage,
  },
  {
    path: "/specialist/dashboard",
    protectedPageName: "Patient Records",
    component: SpecialistDashboard,
  },
  {
    path: "/specialist/dashboard/:id",
    protectedPageName: "Patient Records",
    component: PatientDetailsView,
  },
  {
    path: "/specialist/dashboard/client/:cid/patient/:id/ledger",
    protectedPageName: "Patient Records",
    component: MasterPatientView,
  },
  {
    path: "/estimate/v3/:eid",
    protectedPageName: "Patient Records",
    component: IOCEstimateDetailsV3,
  },
  {
    path: "/estimate/v4/:eid",
    protectedPageName: "Patient Records",
    component: IOCEstimateDetailsV4,
  },
  {
    path: "/estimate/v5/:eid",
    protectedPageName: "Patient Records",
    component: EstimatePreviewSummary,
  },
  {
    path: "/specialist/dashboard/dispute/:did",
    protectedPageName: "Patient Records",
    component: DisputeResponse
  },

  //access-denied
  { path: "/accessdenied", component: AccessDeniedView },

  // Misc
  { path: "/privacypolicy", component: PrivacyPolicyView },
  {
    path: "/sign-document/:helloSignRequestId",
    protectedPageName: "Forward Document",
    component: ForwardDocumentsView,
  },
  {
    path: "/sign-doc/patient/:patientId/encounter/:encounterId",
    component: ClientDocumentSign,
  },
  {
    path: "/patients",
    component: EstimatesView,
  },
  {
    path: "/patients/:patientId/vob/:vobId",
    component: EstimatesView,
  },
  {
    path: "/patients/:patientId/estimate/:estimateId/risk",
    component: EstimatesView,
  },
  {
    path: "/patients/:patientId/vob",
    component: EstimatesView,
  },
  {
    path: "/patients/:patientId/estimate",
    component: EstimatesView,
  },
  {
    path: "/patients/:patientId",
    component: EstimatesView,
  },
  {
    path: "/patients/:patientId/estimate/:estimateId",
    component: EstimatesView,
  },
  {
    path: "/crm",
    component: CrmIntegration,
  },
  // Payment Hub - Mobile routes
  {
    path: "/mobile/patient/:patientId/ioc/:patientEncounterId/no-payment-programs",
    component: MobileNoPaymentProgramsView,
  },
  {
    path: "/mobile/patient/:patientId/ioc/:patientEncounterId/program/custom-results",
    component: MobilePaymentProgramView,
  },
  {
    path: "/mobile/patient/:patientId/ioc/:patientEncounterId/program/:programType",
    component: MobilePaymentProgramView,
  },
  {
    path: "/mobile/patient/:patientId/ioc/:patientEncounterId/program",
    component: MobilePaymentProgramView,
  },
  {
    path: "/mobile/patient/:patientId/ioc/:patientEncounterId/pay",
    component: PaymentHubView,
  },
  {
    path: "/hub/patient/:patientId/ioc/:patientEncounterId/program/custom-results",
    protectedPageName: "Payment Hub",
    component: PaymentProgramView,
  },
  {
    path: "/hub/patient/:patientId/ioc/:patientEncounterId/program/:programType",
    protectedPageName: "Payment Hub",
    component: PaymentProgramView,
  },
  {
    path: "/hub/patient/:patientId/ioc/:patientEncounterId/program",
    protectedPageName: "Payment Hub",
    component: PaymentProgramView,
  },
  {
    path: "/hub/patient/:patientId/ioc/:patientEncounterId/pay",
    protectedPageName: "Payment Hub",
    component: PaymentHubView,
  },
  {
    path: "/hub/patient/:patientId/ioc/:patientEncounterId/pay/change-recurring",
    protectedPageName: "Payment Hub",
    component: RecurringPaymentMethodView,
  },
  {
    path: "/hub/patient/:patientId/ioc/:patientEncounterId/refinance",
    protectedPageName: "Payment Hub",
    component: RefinanceView,
  },
  {
    path: "/hub/patient/:patientId/ioc/:patientEncounterId",
    protectedPageName: "Payment Hub",
    component: HubView,
  },
  {
    path: "/hub/patient/:patientId",
    protectedPageName: "Payment Hub",
    component: HubView,
  },
  {
    path: "/hub/patient",
    protectedPageName: "Payment Hub",
    component: NewPatientView,
  },
  {
    path: "/hub",
    protectedPageName: "Payment Hub",
    component: HubView,
  },
];

export default RouteConfiguration;
